import { api } from '@/shared/axios-client';
import type { backendPipeline } from './detectRepository';

export interface TestScriptCandidate {
  filePath: string;
  fileName: string;
  size?: number;
  selectedByDefault?: boolean;
}

export interface ReleasePipelineSelection {
  releaseDefinitionId: number;
  releasePipelineName?: string;
  environmentNames?: string[];
}

export interface ScriptCandidatesRequest {
  organization: string;
  project: string;
  testOrgName: string;
  testProjectName: string;
  testRepoUrl: string;
  testBranchName: string;
  testPat?: string;
  testScriptsRootPath?: string;
  testScriptsRootPaths?: string[];
  releaseConfig?: {
    organization: string;
    project: string;
    pat: string;
    pipelines: backendPipeline[];
  };
  releaseSelections?: ReleasePipelineSelection[];
}

export interface ScriptCandidatesResponse {
  success: boolean;
  message: string;
  candidates: TestScriptCandidate[];
  summary?: {
    adoFilesListed?: number;
    candidateCount?: number;
    hintCount?: number;
    unresolvedTcCount?: number;
  };
  unresolvedTcPaths?: string[];
}

export async function getScriptCandidates(
  body: ScriptCandidatesRequest,
  patToken: string,
): Promise<ScriptCandidatesResponse> {
  return api.post('/api/test-automation/script-candidates', body, {
    headers: {
      'Requester-Token': patToken,
      'Content-Type': 'application/json',
    },
  }) as Promise<ScriptCandidatesResponse>;
}



